export const formatPrice = (amount: number, currency?: string) =>
  (amount / 100).toFixed(amount % 100 === 0 ? 0 : 2) + ((currency && ' ' + currency.toUpperCase()) || '');
